import React from "react";
import { useUserStore } from "../../stores/user.store";
import { useGetProgramsByIds } from "../../hooks/useBeneficiaries";
import LegacyProviderReport from "./LegacyProviderReport";
import MultiTreatmentProviderReport from "./MultiTreatmentProviderReport";

const ProviderReport: React.FC = () => {
	const { userInfo } = useUserStore();

	const userProgramsIds =
		userInfo?.programs.map((program) => program.programId) || [];

	const { data: programs } = useGetProgramsByIds(userProgramsIds);

	// Check if any of the user's programs have multi-treatment plans
	const hasMultiTreatmentProgram = programs?.some(
		(program) => program.multiTreatmentPlan === true,
	);

	// If user has multi-treatment programs, show the MultiTreatmentProviderReport
	// Otherwise, show the legacy ProviderReport
	if (hasMultiTreatmentProgram) {
		return <MultiTreatmentProviderReport />;
	}

	return <LegacyProviderReport />;
};

export default ProviderReport;
